import {
  DragAndDropCardWrapper,
  DragAndDropSectionsProvider,
} from '@ardoq/drag-and-drop';
import { InternalTab } from './Tab';
import { resolveActiveTabId } from './resolveActiveTabId';
import { ReorderableTabListProps } from './types';

export const ReorderableTabList = <T extends string = string>({
  children,
  activeTabId,
  onTabChange,
  onReorder,
  tablistAriaLabel,
  clickNamespace,
}: ReorderableTabListProps<T>) => {
  const resolvedActiveTabId = resolveActiveTabId(activeTabId, children);
  const handleDrop = (newOrder: string[]) => onReorder(newOrder as T[]);

  return (
    <div
      role="tablist"
      aria-label={tablistAriaLabel}
      data-click-namespace={clickNamespace}
    >
      <DragAndDropSectionsProvider orientation="wrap" onDrop={handleDrop}>
        {children.map(child => (
          <DragAndDropCardWrapper
            key={child.props.tabId}
            dragAndDropCardId={child.props.tabId}
            dragHandle="card"
            role="presentation"
          >
            <InternalTab
              {...child.props}
              isActive={resolvedActiveTabId === child.props.tabId}
              hasDragHandle
              onClick={() => onTabChange(child.props.tabId)}
            />
          </DragAndDropCardWrapper>
        ))}
      </DragAndDropSectionsProvider>
    </div>
  );
};
